import { render, staticRenderFns } from "./student_course_class.vue?vue&type=template&id=50f88fd4&scoped=true"
import script from "./student_course_class.vue?vue&type=script&lang=ts"
export * from "./student_course_class.vue?vue&type=script&lang=ts"
import style0 from "./student_course_class.vue?vue&type=style&index=0&id=50f88fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f88fd4",
  null
  
)

export default component.exports